import useTranslation from '../../../hooks/useTranslation'
import Container from '../../../UI/Container/Container'
import arrow from '../../../../assets/image/arrow.png'

const ContactForm: React.FC<{}> = () => {
  const t = useTranslation()

  return (
    <div className="bg-beige py-10 md:py-10">
      <Container>
        <div className="flex flex-row gap-5 md:gap-10 justify-between items-center">
          {t.home.separator.bullets.map((bullet, index) => (
            <div key={index} className="flex items-center gap-1 md:gap-3">
              <img src={arrow} className="w-2 md:w-3" alt="" />
              <div className="text-xs md:text-lg font-bold uppercase">{bullet}</div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default ContactForm
